export default __webpack_public_path__ + "6ab30329b4e7bed5fd64b9e694fee43e.png";